<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <div class="l-page__header c-page__header">
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        维保项目管理
      </h2>
      <div class="c-page__header-btns">
        <k-button
          type="primary"
          icon="kestrel-icon ki-search"
          btn-text="查询"
          @click="refreshSearch"
        />
        <k-button
          icon="kestrel-icon ki-repeat"
          btn-text="重置"
          @click="resetForm"
        />
        <k-button
          v-if="isProjectManager"
          type="success"
          icon="kestrel-icon ki-plus"
          btn-text="新增"
          :auth-type="false"
          @click="openNavTab({ name: 'jxxfWbProjectCreate' })"
        />
      </div>
    </div>
    <div class="l-page__item l-page--search__item">
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :inline="true"
          label-position="right"
          label-width="80px"
          label-suffix="："
        >
          <el-row class="c-form__row">
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="项目名称"
              >
                <el-input
                  v-model.trim="filterParams.xmmc"
                  class="c-form__input"
                  placeholder="请输入项目名称"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="委托单位"
              >
                <el-input
                  v-model.trim="filterParams.wtdwmc"
                  class="c-form__input"
                  placeholder="请输入委托单位"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </hm-page-card>
    </div>
    <div class="l-page__body l-page--search__body">
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane label="查询结果">
          <k-table
            ref="kTable"
            height="100%"
            :table-column="tableColumn"
            :data="page.rows"
            :pagination="page"
            @current-change="search"
            @size-change="handleSizeChange"
          >
            <template #xmmc="scope">
              <el-link
                type="primary"
                @click="openNavTab({ name: 'jxxfWbProjectDetail', params: { xmId: scope.row.uuid } })"
              >
                {{ scope.row.xmmc }}
              </el-link>
            </template>
            <el-table-column
              v-if="isProjectManager"
              label="操作"
              width="150"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <k-button
                  btn-text="编辑"
                  :auth-type="false"
                  type="primary"
                  plain
                  @click="openNavTab({ name: 'jxxfWbProjectEdit', params: { xmId: scope.row.uuid } })"
                />
                <k-button
                  v-if="isProjectManager && !scope.row.ywcjhsl"
                  btn-text="删除"
                  :auth-type="false"
                  type="danger"
                  plain
                  @click="deleteProject(scope.row)"
                />
              </template>
            </el-table-column>
          </k-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { projectService } from './project.service';

export default {
  name: 'JxxfWbProjectIndex',
  data () {
    return {
      loading: false,
      isProjectManager: false,
      filterParams: {
        xmmc: null,
        wtdwmc: null
      },
      trueFilterParams: {},
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      tableColumn: [{
        key: 'index',
        label: '序号',
        align: 'center',
        width: this.$commonConfig.tableWidthConfig.common_xh,
        type: 'index'
      }, {
        key: 'xmmc',
        slotName: 'xmmc',
        label: '项目名称',
        align: 'left',
        minWidth: '180',
        type: 'text'
      }, {
        key: 'wtdwmc',
        label: '委托单位',
        align: 'left',
        minWidth: '160',
        type: 'text'
      }, {
        key: 'xmdz',
        label: '项目地址',
        align: 'left',
        minWidth: '220',
        type: 'text'
      }, {
        key: 'jzwsl',
        label: '建筑物',
        align: 'right',
        width: '90',
        type: 'text'
      }, {
        key: 'sssl',
        label: '设施系统',
        align: 'right',
        width: '100',
        type: 'text'
      }, {
        key: 'jhsl',
        label: '计划数',
        align: 'right',
        width: '80',
        type: 'text'
      }]
    };
  },
  methods: {
    /** 保存查询条件并从第一页开始查询。 */ refreshSearch () {
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      this.search(1);
    },
    /** 使用当前分页参数加载项目列表。 */ search (pageNo = 1) {
      this.loading = true;
      projectService.page(Object.assign({}, this.trueFilterParams, {
        pageNo,
        pageSize: this.page.pageSize
      })).then(rsp => {
        this.page = Object.assign({}, this.page, rsp.data);
      }).finally(() => {
        this.loading = false;
      });
    },
    /** 使用统一表格组件的页大小重新查询。 */ handleSizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.search(1);
    },
    /** 删除江西维保项目。 */ deleteProject (row) {
      this.$confirm(`确认删除项目：${row.xmmc}？`, '提示', { type: 'warning' }).then(() => projectService.delete(row.uuid)).then(() => {
        this.$message.success('删除成功');
        this.search(1);
      });
    },
    /** 清空查询条件。 */ resetForm () {
      this.$refs.filterParams.resetFields();
    }
  },
  created () {
    this.isProjectManager = ((this.$HMStoreService.getUserinfo() || {}).roles || []).includes('JX-XMGLY');
    this.refreshSearch();
  },
  activated () {
    if (this.$route.params.isRefresh) {
      this.refreshSearch();
    }
  }
};
</script>
